

<div class="qNot">
    <div class="qNot__bell" [matMenuTriggerFor]="notification">
        <i class="bi bi-bell"></i>
        @if(quickNotification && quickNotification.length){
            <span class="qNot__bell--alert">{{quickNotification.length}}</span>
        }
    </div>
    <mat-menu #notification="matMenu" xPosition="before" class="header__notificationDrop">
        <div>
            <div (click)="$event.stopPropagation()">
                <p class="qNot__heading px-3 pt-3 m-0">Notifications</p>
                @if(quickNotification && quickNotification.length){
                    @for(item of quickNotification; let i = $index; track item){
                        @if(i < quickNotificationLength){
                        <div class="p-3 qNot__separator">
                            <div class="d-flex">
                                <div class="mt-1 me-2">
                                    @if(item.type === 'OUT OF MARKET'){
                                        <i class="bi bi-bag-x qNot__notTypeIcon qNot__notTypeIcon--oom"></i>
                                    }
                                    @else if(item.type === 'NO LABEL'){
                                        <i class="bi bi-upc-scan qNot__notTypeIcon qNot__notTypeIcon--nol"></i>
                                    }
                                    @else if(item.type === 'MISSING'){
                                        <i class="bi bi-aspect-ratio qNot__notTypeIcon qNot__notTypeIcon--mpal"></i>
                                    }
                                    @else if(item.type === 'STORE'){
                                        <i class="bi bi-shop qNot__notTypeIcon qNot__notTypeIcon--store"></i>
                                    }
                                    @else if(item.type === 'ERROR SHIP ADVICE' || item.type === 'SHIP ADVICE'){
                                        <i class="bi bi-file-earmark-spreadsheet qNot__notTypeIcon qNot__notTypeIcon--shipAdvice"></i>
                                    }
                                </div>
                                <div>
                                    <div class="d-flex justify-content-between">
                                        @if(item.type === 'OUT OF MARKET'){
                                            <p class="qNot__notType mb-0 text-nowrap text-uppercase">Out of market</p>
                                        }
                                        @else if(item.type === 'NO LABEL'){
                                            <p class="qNot__notType mb-0 text-nowrap text-uppercase">No label</p>
                                        }
                                        @else if(item.type === 'MISSING'){
                                            <p class="qNot__notType mb-0 text-nowrap text-uppercase">Missing Pallets</p>
                                        }
                                    </div>
                                    <p class="qNot__notContent mb-0">
                                        @if(currentProfile === 0){
                                            <b>{{item.orgId}} - </b>
                                        }
                                        @if(item.transferId){
                                            <!-- @if(((currentRole === 0 || currentRole === 1 || currentRole === 99) && (item.type === 'OUT OF MARKET' || item.type === 'NO LABEL') && item.transferCarrier !== 'FedEx')){
                                                <a href="javascript:void(0)" (click)="download(item)">{{item.transferId}}</a>
                                            }
                                            @else {
                                                {{item.transferId}}
                                            } -->
                                            {{item.transferId}}
                                        }
                                        {{item.notificationDesc}}
                                    </p>
                                    @if(item.action){
                                        <a href="javascript:void(0)" class="qNot__dismiss me-3" (click)="goToTransfer(item)">Transfer</a>
                                    }
                                    
                                    @if(!(currentProfile === 0 && (item.type === 'OUT OF MARKET' || item.type === 'NO LABEL'))){
                                        <a href="javascript:void(0)" class="qNot__dismiss" (click)="dismiss(item.id)">Dismiss</a>
                                    }
                                    
                                </div>
                            </div>
                        </div>
                        }
                        
                    }
                } 
                @else {
                    <p class="p-3 qNot__allGood">All looks good. No new notifications.</p>
                }
            </div>
            @if(quickNotification && quickNotification.length > quickNotificationLength){
                <div class="py-3 text-center">
                    <a href="javascript:void(0)" (click)="viewAll()" class="qNot__viewAll">Show All</a>
                </div>
            }
        </div>
    </mat-menu>
</div>